const config = {
  projectsCalendarUrl: "", // Url do pobierania składowych projektów
  projectsCalendarUrlAdd: "", // Url strony dodania nowej składowej projektu
  projectsCalendarUrlDetails: "", // Url do pobierania szczegółów składowej projektu
  projectsCalendarView: "timelineRangeArea", // timelineDay, timelineWeek, timelineMonth, timeline7Days, timeline3Months, timelineRange, timelineRangeArea
  projectsCalendarBusinessHoursStart: "", // "00:00" - godzina początkowa dla godzin biznesowych
  projectsCalendarBusinessHoursEnd: "", // "00:00" - godzina końcowa dla godzin biznesowych
  projectsCalendarStart: 0, // data początkowa (timelineDay)
  projectsCalendarEnd: 0, // data końcowa (timelineDay)
  projectsCalendarPopoverTrigger: "mouseenter", // click - popover po kliknięciu, mouseenter - popover po najechaniu kursorem myszki
  projectsCalendarPopoverTimeout: 500, // czas po jakim zostaje wysłane żądanie Ajax dla popover'a.
  projectsCalendarHideEmptyResources: false, // Ukrywanie pustych powierzchni
  projectsCalendarCustomStylesheetRules: [
    // ".projects-calendar__project { padding: 0.5rem 0 }",
    // ".projects-calendar__project-description > span { margin: 0 1rem; font-size: 1rem }",
  ],
  projectsCalendarButtons: {
    select: {
      text: "",
      title: "Wybierz datę z kalendarza",
      icon: "far fa-calendar-alt",
    },
    today: {
      text: "Dzisiaj",
      title: "Wybierz dzisiejszą datę",
      icon: "",
    },
    prev: {
      text: "",
      title: "Poprzedni",
      icon: "fas fa-chevron-left",
    },
    next: {
      text: "",
      title: "Następny",
      icon: "fas fa-chevron-right",
    },
    fullscreen: {
      enabled: {
        text: "",
        title: "Opuść tryb pełnoekranowy",
        icon: "fas fa-compress",
      },
      disabled: {
        text: "",
        title: "Pełny ekran",
        icon: "fas fa-expand",
      },
    },
  }, // Domyślne przyciski
  projectsCalendarCustomButtons: {
    custom: {
      text: "Tekst przycisku", // Tekst przycisku
      title: "Tekst przycisku", // Atrybut title=""
      icon: "", // Ikona np. "far fa-calendar-alt"
    },
  }, // Dodatkowe przyciski użytkownika
  projectsCalendarCustomButtonsFunctions: {
    custom: {
      click: () => {
        console.log("Klik!"); // Funkcja wywołana po kliknięciu w przycisk "custom".
      },
    },
  }, // Dodatkowe funkcje użytkownika
  projectsCalendarHeader: {
    left: ["buttons:select", "buttons:today", "buttons:prev,next", "buttons:fullscreen"],
    center: ["texts:title"],
    right: [
      "resources:timelineDay,timelineDayArea,timelineWeek,timelineWeekArea,timelineMonth,timelineMonthArea,timeline7Days,timeline7DaysArea,timeline3Months,timeline3MonthsArea,timelineRange,timelineRangeArea",
    ],
  }, // Domyślne przyciski "date", "today", "prev", "next", "fullscreen". Możemy też grupować np. "prev,next".
  projectsCalendarResources: {
    timelineDay: {
      label: "Dzień",
      type: "date", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      duration: {
        days: 1,
      }, // days, weeks, months, years
      headerLabelFormat: {
        start: {
          dateStyle: "full",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineDayArea: {
      label: "Dzień - powierzchnie",
      type: "area", // date - widok według daty, area - widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      duration: {
        days: 1,
      }, // days, weeks, months, years
      headerLabelFormat: {
        start: {
          dateStyle: "full",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineWeek: {
      label: "Tydzień",
      type: "date", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      duration: {
        weeks: 1,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentDay: {
          start: {
            day: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineWeekArea: {
      label: "Tydzień - powierzchnia",
      type: "area", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "06:00:00",
      slotDuration: "06:00:00",
      slotWidth: 70,
      duration: {
        weeks: 1,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentDay: {
          start: {
            day: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineMonth: {
      label: "Miesiąc",
      type: "date", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      duration: {
        months: 1,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentDay: {
          start: {
            month: "long",
            year: "numeric",
          },
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineMonthArea: {
      label: "Miesiąc - powierzchnia",
      type: "area", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "06:00:00",
      slotDuration: "06:00:00",
      slotWidth: 70,
      duration: {
        months: 1,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentDay: {
          start: {
            month: "long",
            year: "numeric",
          },
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timeline7Days: {
      label: "7 dni",
      type: "date", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      duration: {
        days: 7,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentDay: {
          start: {
            day: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timeline7DaysArea: {
      label: "7 dni - powierzchnie",
      type: "area", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "06:00:00",
      slotDuration: "06:00:00",
      slotWidth: 70,
      duration: {
        days: 7,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentDay: {
          start: {
            day: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timeline3Months: {
      label: "3 miesiące",
      type: "date", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      duration: {
        months: 3,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timeline3MonthsArea: {
      label: "3 miesiące - powierzchnie",
      type: "area", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "06:00:00",
      slotDuration: "06:00:00",
      slotWidth: 70,
      duration: {
        months: 3,
      }, // days, weeks, months, years
      headerLabelFormat: {
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineRange: {
      label: "Zakres",
      type: "date", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "01:00:00",
      slotDuration: "01:00:00",
      slotWidth: 70,
      headerLabelFormat: {
        start: {
          dateStyle: "full",
        },
        differentDay: {
          start: {
            day: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
    timelineRangeArea: {
      label: "Zakres - powierzchnie",
      type: "area", // date — widok według daty, area — widok według powierzchni
      slotLabelInterval: "06:00:00",
      slotDuration: "06:00:00",
      slotWidth: 70,
      headerLabelFormat: {
        start: {
          dateStyle: "full",
        },
        differentDay: {
          start: {
            day: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentMonth: {
          start: {
            day: "numeric",
            month: "long",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
        differentYear: {
          start: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          end: {
            day: "numeric",
            month: "long",
            year: "numeric",
          },
          separator: "-",
        },
      },
      slotLabelFormat: [
        {
          type: "year",
          format: {
            year: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "month",
          format: {
            month: "long", // "2-digit", "long", "narrow", "numeric", "short"
          },
        },
        {
          type: "weekday",
          format: {
            weekday: "long", // "long", "short", "narrow"
            day: "numeric", // "2-digit", "numeric"
          },
        },
        {
          type: "hour",
          format: {
            timeStyle: "short", // "full", "long", "medium", "short"
          },
        },
      ],
    },
  }, // ustawienia widoków
  projectsCalendarFullScreenMode: false, // Tryb pełnoekranowy
};

export { config };
